import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const LocalWork = () => {
  return (
    <section className="py-20 bg-[#07113a] border-y border-[#344271]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="text-[#94a3b8] font-bold tracking-widest uppercase text-xs mb-3 block">Recent Local Work</span>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <motion.a
            href="https://twocows-proposal.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex items-center p-6 bg-[#2a3658]/40 border border-[#344271] rounded-2xl hover:border-[#3b82f6]/30 transition-all group backdrop-blur-sm shadow-xl"
          >
            <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-xl flex items-center justify-center mr-6 font-bold text-[#3b82f6] border border-[#344271]">TC</div>
            <div>
              <h4 className="text-white font-bold text-lg mb-1 group-hover:text-white transition-colors">Two Cows Creamery and Bistro</h4>
              <p className="text-[#e2e8f0]/60 text-sm">Website proposal for a local bistro</p>
            </div>
            <SafeIcon icon={FiExternalLink} className="ml-auto text-white/20 group-hover:text-[#3b82f6] transition-colors" />
          </motion.a>

          <div className="flex items-center p-6 border border-dashed border-[#344271] rounded-2xl">
            <p className="text-[#94a3b8] italic text-sm">More local work samples available on request.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalWork;